import React from 'react';
import compose from 'recompose/compose';
import { Button, Link, Typography } from '@material-ui/core';
import { getI18nFormattedMessage } from '../../../../utils/intl';
import { SUCCESS } from '../../../../constants';
import { get } from 'lodash';

import { arrayOf, bool, func, object, string } from 'prop-types';
import moment from 'moment';
import SimpleTable from '../../../../components/Table/simpleTable';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { hasAdminRole } from '../../../../utils';


export const MultiRequestTable = (props) => {
  const {
    sectionType,
    columns,
    rows,
    classes,
    onReview,
    user,
    entityUuid,
    hasRowHeader,
    onWithdraw,
    isAdmin,
  } = props;

  const getUserName = (item) =>
    hasAdminRole(user) ?
    (<Link href={`/admin/console/users/details/${item.userUuid}`}>
      {item.modifiedBy}
    </Link>) :
    (<span>
      {item.modifiedBy}
    </span>)

const sectionTypeRequestTypeMap = {
    'apikeys': 'APPLICATION_API_KEYS',
    'apis': 'PATCH_APPLICATION_APIS',
    'apiplans': 'PATCH_APPLICATION_API_PLANS',
    'certificates': 'APPLICATION_CERTIFICATES',
    'products':  'PATCH_APPLICATION_PRODUCTS',
    'oauthclients': 'APPLICATION_OAUTH_CLIENTS',
  };

  const getActionPanel = (item, containerClassName) => (
    <>
      {(sectionType !== 'products') || (isAdmin && sectionType === 'products') ?
        <span id="buttons"
        className={containerClassName}
        >
          <Button
            id="accept-button"
            data-apim-test="accept-button"
            variant="text"
            color="secondary"
            className={classes.acceptButton}
            onClick={() => onReview('REQUEST', 'accept', item.uuid, sectionType)}
          >
            {getI18nFormattedMessage('label.application.details.section.accept.button')}
          </Button>
          <Button
            variant="text"
            id="reject-button"
            data-apim-test="reject-button"
            className={classes.rejectButtonText}
            onClick={() => onReview('REQUEST', 'reject', item.uuid, sectionType)}
            >
            {getI18nFormattedMessage('label.application.details.section.reject.button')}
          </Button>
        </span>
      : get(user, 'uuid') === item.userUuid &&
        (<span id="buttons"
        className={containerClassName}
        >
          <Button
            id="accept-button"
            data-apim-test="accept-button"
            variant="text"
            color="secondary"
            className={classes.acceptButton}
            onClick={() => onWithdraw( item.uuid)}
          >
            {getI18nFormattedMessage('label.withdraw')}
          </Button>
        </span>)
      }
    </>
  );

  const getRequestSubTitle = (item) => {
    if (sectionType === 'apikeys' || sectionType === 'oauthclients') {
      if (item.requestSubtype === 'CREATE') {
        return getI18nFormattedMessage("label.request.details.requestor.create.sub.title");
      } else if (item.requestSubtype === 'UPDATE') {
        return getI18nFormattedMessage("label.request.details.requestor.update.sub.title");
      }
      return getI18nFormattedMessage("label.request.details.requestor.delete.sub.title");
    }
    return getI18nFormattedMessage("label.request.details.requestor.sub.title");
  };

  const getRowHeaderApisColumn =
    {
      id: 'action',
      secondaryId: 'requestEntities',
      format: (item) => {
        return (
          <span className={classes.colContainer}>
            <span>
              {getRequestSubTitle(item)} {getUserName(item)} • {getI18nFormattedMessage("label.request.details.requestdate.sub.title")}:
              {moment(item.modifyTs).format('ddd, MMM DD, YYYY HH:mm:ss ([GMT]Z)')}
            </span>
            {getActionPanel(item, sectionType === 'apiplans' || sectionType === 'products'
              ? classes.buttonApiPlanContainer : classes.buttonApisContainer)}
          </span>
        )
      },
    };
    const getColumns = () => {
      if(hasRowHeader) {
        return columns;
      } else {
        return [
          ...columns,
          {
            id: 'actions',
            label: getI18nFormattedMessage('label.request.details.section.request.action.column.title'),
            value: (item) => item,
            format: (item) => getActionPanel(item),
          },
        ]
      }
    }
  
  return(
    <>
      <div className={classes.tableHead}>
        <Typography variant="h4">
          {getI18nFormattedMessage(`label.request.details.section.title.${sectionType}`)}
        </Typography>
        {((sectionType !== 'products') || (isAdmin && sectionType === 'products')) &&
          <div id="buttons" className={classes.buttonDiv}>
            <Button
              id="accept-button"
              data-apim-test="accept-button"
              variant="contained"
              color="secondary"
              className={classes.acceptButton}
              onClick={() => onReview('REQUEST', 'accept', entityUuid, sectionType, sectionTypeRequestTypeMap[sectionType])}
            >
              {getI18nFormattedMessage('label.application.details.section.accept.all.button')}
            </Button>
            <Button
              id="reject-button"
              data-apim-test="reject-button"
              className={classes.rejectButton}
              onClick={() => onReview('REQUEST', 'reject', entityUuid, sectionType, sectionTypeRequestTypeMap[sectionType])}
              >
              {getI18nFormattedMessage('label.application.details.section.reject.all.button')}
            </Button>
          </div>
        }
      </div>
      <SimpleTable
        id={`${sectionType}-list`}
        columns={getColumns()}
        rows={rows}
        hasRowHeader={hasRowHeader}
        rowHeaderColumn={getRowHeaderApisColumn}
        colsPanCount={columns.length}
        columnContainerClass={classes.columnHeader}
      />
      <div className={classes.tableFooter}>
        {sectionType === "apikeys" &&
          <Typography variant="body1" className={classes.keyNote}>
            {getI18nFormattedMessage("label.request.details.keys.more.note")}
          </Typography>
        }
      </div>
   </>
  );
}

MultiRequestTable.propTypes = {
  sectionType: string,
  columns: object,
  rows: object,
  classes: object,
  onReview: func,
  actionStatus: string,
  user: object,
  entityUuid: string,
  hasRowHeader: bool,
  isAdmin: bool,
  onWithdraw: func,
  isPublisherRole: bool,
};


export const RequestSectionTable = (props) => {
  const {
    sectionType,
    columns,
    rows,
    requestInfo,
    classes,
    onReview,
    actionStatus,
    user,
    onWithdraw,
    isAdmin,
  } = props;
  const getUserName = () => hasAdminRole(user) ?
  (<Link href={`/admin/console/users/details/${requestInfo.userUuid}`}>
    {requestInfo.modifiedBy}
  </Link>) :
  (<span>
    {requestInfo.modifiedBy}
  </span>);
  return (
    <div
      id={`section-table-page-${sectionType}`} data-layer7-test={`section-table-page-${sectionType}`}
    >
        <div className={classes.tableHead}>
          {sectionType !== 'registration' &&
            <Typography variant="h4">
              {getI18nFormattedMessage(`label.request.details.section.title.${sectionType}`)}
            </Typography>
          }
          <div id="buttons" className={classes.buttonDiv}>
            {requestInfo && sectionType !== 'status' && (!actionStatus || actionStatus.status !== SUCCESS) &&
              <>
                <Button
                  id="accept-button"
                  data-apim-test="accept-button"
                  variant="contained"
                  color="secondary"
                  className={classes.acceptButton}
                  onClick={() => onReview('REQUEST', 'accept', requestInfo.uuid, sectionType)}
                >
                  {getI18nFormattedMessage('label.application.details.section.accept.button')}
                </Button>
                <Button
                  id="reject-button"
                  data-apim-test="reject-button"
                  className={classes.rejectButton}
                  onClick={() => onReview('REQUEST', 'reject', requestInfo.uuid, sectionType)}
                  >
                  {getI18nFormattedMessage('label.application.details.section.reject.button')}
                </Button>
              </>
            }
            {!isAdmin && get(user, 'uuid') === get(requestInfo, 'userUuid') &&
              <Button
                id="withdraw-button"
                data-apim-test="withdraw-button"
                variant="outlined"
                className={classes.withdrawButton}
                onClick={() => onWithdraw(requestInfo.uuid)}
              >
                {getI18nFormattedMessage('label.withdraw')}
              </Button>
            }
          </div>
        </div>
        { actionStatus && actionStatus.status === SUCCESS ?
        <div className={classes.notificationDiv}>
          <CheckCircleIcon className={classes.checkIcon}/>
          <div className={classes.notification}>
            <span>{getI18nFormattedMessage('label.applicaiton.details.section.action.request.text')}</span>
            <span className={classes.acceptedText}>
              {getI18nFormattedMessage(`label.applicaiton.details.section.action.${actionStatus.actionType}.notification`)}
            </span>
          </div>
        </div> :
        <>
          <SimpleTable
            id={`${sectionType}-list`}
            columns={columns}
            rows={rows}
          />
          <div className={classes.tableFooter}>
            {requestInfo && sectionType !== 'status' &&
              <Typography variant="body1">
                {getI18nFormattedMessage("label.request.details.requestdate.sub.title")}: {moment(requestInfo.modifyTs).format('ddd, MMM DD, YYYY HH:mm:ss ([GMT]Z)')} • {getI18nFormattedMessage("label.request.details.requestor.sub.title")}
                {getUserName()}
              </Typography>
            }
            {sectionType === "apikeys" &&
              <Typography variant="body1" className={classes.keyNote}>
                {getI18nFormattedMessage("label.request.details.keys.more.note")}
              </Typography>
            }
          </div>
        </>
        }
    </div>
  );
};
RequestSectionTable.propTypes = {
  sectionType: string,
  columns: object,
  rows: object,
  requestInfo: arrayOf(object),
  classes: object,
  onReview: func,
  actionStatus: string,
  user: object,
  isAdmin: bool,
  onWithdraw: func,
  isPublisherRole: bool,
};

export default compose()(RequestSectionTable);
